import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import contactNoteDialogService from 'services/contactNoteDialogService';
import { AuditHistoryResponse } from 'views/ContactNoteDetails/Components/ContactNoteAuditHistory';

export const useGetAuditHistoryStatus = (id: string) => {
  return useQuery<AuditHistoryResponse[], AxiosError>({
    queryKey: ['audit-history', id],
    queryFn: () => contactNoteDialogService.getAuditHistory(id),
  });
};
